/**
 * #988 — logout canvas clear without pulling designStore into the entry graph.
 *
 * A dynamic `import('./designStore')` inside authStore still makes Vite
 * modulepreload vendor-fabric on every page (including the homepage). Instead,
 * designStore registers a clearer when its chunk actually loads; logout only
 * invokes the clearer if present (no-op on marketing pages that never opened
 * the editor).
 */

type Clearer = () => void;

let clearer: Clearer | null = null;

export function registerDesignLogoutClearer(fn: Clearer): void {
  clearer = fn;
}

export function runDesignLogoutClearer(): void {
  try {
    clearer?.();
  } catch {
    // Editor clear must never block auth reset.
  }
}

/** Test helper — reset between unit tests. */
export function __resetDesignLogoutClearerForTests(): void {
  clearer = null;
}
